import { Col, Row } from 'antd';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import OrdersTable from 'modules/orders/components/OrdersTable';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const OrdersPage: FC = () => {
  const { t } = useTranslation('orders.OrdersPage');
  return (
    <ProfileSideMenuWrapper title={t('orders')}>
      <Row>
        <Col span={24}>
          <OrdersTable />
        </Col>
      </Row>
    </ProfileSideMenuWrapper>
  );
};

export default OrdersPage;
